"use client";

import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAddressStore } from "@/store/address.store";
import { useAuthStore } from "@/store/auth.store";
import { refreshForLocationChange } from "@/lib/location-refresh";

/**
 * Aligne les onglets ouverts sur la même adresse.
 *
 * L'adresse est persistée dans le stockage local, mais zustand ne relit ce
 * stockage qu'au démarrage : un onglet resté ouvert gardait donc l'ancienne
 * position indéfiniment. Mesuré — adresse changée pour Bab Ezzouar dans un
 * onglet, le second affichait toujours El Achour et ses magasins.
 *
 * C'est trompeur au-delà de l'affichage : la position du compte, elle, a
 * changé côté serveur. L'onglet en retard proposait donc des magasins d'une
 * ville et aurait commandé dans une autre.
 *
 * L'événement `storage` n'est émis QUE vers les autres onglets, jamais vers
 * celui qui écrit — aucun risque de boucle.
 */
export function AddressTabSync() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key !== "fast-address") return;
      // Relit le stockage et notifie les abonnés du magasin.
      useAddressStore.persist.rehydrate();
      refreshForLocationChange(queryClient, !!useAuthStore.getState().user);
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [queryClient]);

  return null;
}
